import React, { useState, useEffect } from "react"
import _ from "lodash"

import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import { SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"
import { NumberInput, DropdownInput } from "components/table/carousel/inputs"
import { field_attrs } from "components/table/lib/column-field"

const FreeRentBasic = (props: {rowData: [], defaults: object, field: string, namedItems: {}, persist: Function}) => {
  const emptyRecord = {
    occupiedMos: null,
    marketMos: null,
    timing: null
  }
  const [data, setData] = useState<object|null>(props.rowData[props.field])

  useEffect(() => {
    if (!props['rowData'][props.field] || props['rowData'][props.field].state !== 'basic') setData(emptyRecord)
  }, [props['rowData']])

  function updateData(val: number, field: string):void {
    let nextData = _.cloneDeep(data);
    nextData[field] = val
    if (!nextData['timing']) nextData['timing'] = props.defaults['freeRentTiming']
    setData(nextData)
    props.persist({...nextData, state: 'basic'}, props.field, props.rowData)
  }

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s>
        <div>
          <label>Occupied</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="occupiedMos" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Market</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="marketMos" readPrecision={2} writePrecision={2} persist={updateData} />
        </div>
        <div>
          <label>Timing</label>
          <DropdownInput className="automated" data={data} attrs={attrs} field="timing" options={['Lease Begin', 'Spread Evenly', 'Lease End']} persist={updateData} default={props.defaults['freeRentTiming']} />
        </div>
      </SingleRowCarouselState_s>
    </div>
  )
}

export default FreeRentBasic
